import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function MembershipNarrative() {
  return <section id="membershipnarrative" className="bg-background">
      <div className="bg-secondary/60 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/dark_gray_marble_bg.png)] py-32 md:py-40 lg:py-48">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl flex flex-col items-center text-center">
          
          {}
          <span className="font-sans font-bold text-sm md:text-base uppercase tracking-brand-widest text-green-accent mb-6 block drop-shadow-[0_0_10px_rgba(143,168,143,0.4)]">
            The M / O Protocol
          </span>

          {}
          <h2 className="font-sans font-extrabold text-4xl md:text-5xl lg:text-6xl text-foreground mb-10 leading-tight">What is M / O Members Only</h2>

          {}
          <div className="max-w-2xl mx-auto space-y-6 mb-16">
            <p className="font-sans text-lg md:text-xl text-foreground leading-relaxed">
              We believe true wellness isn't a luxury—it's a standard. The M/O Protocol is built on three foundational pillars: unparalleled <strong className="font-semibold text-foreground">access</strong>, unwavering <strong className="font-semibold text-foreground">support</strong>, and actionable <strong className="font-semibold text-foreground">data</strong>.
            </p>
            <p className="font-sans text-lg md:text-xl text-foreground leading-relaxed">
              Optimizing your health requires more than occasional visits; it demands a continuous, integrated approach. Our membership is designed to seamlessly weave premium medical and self-care services into your daily life, providing clarity and direction on your wellness journey.
            </p>
          </div>

          <Separator className="w-24 bg-[#A89080] mb-16" />

          {}
          <div className="w-full max-w-3xl bg-muted text-foreground p-10 md:p-16 rounded-2xl shadow-2xl relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-2 bg-[var(--color-green-accent)] opacity-80"></div>
            
            <p className="font-sans font-medium text-2xl md:text-3xl lg:text-4xl leading-snug md:leading-normal" style={{
            letterSpacing: '-0.02em'
          }}>
              "A systemic approach to your well-being, ensuring you have the tools, treatments, and guidance exactly when you need them."
            </p>
            
            <div className="mt-10">
              <Button asChild size="lg" variant="secondary" className="font-serif tracking-wide rounded-full px-8 bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 hover:drop-shadow-md transition-all" style={{
              fontFamily: 'var(--font-serif)'
            }}>
                <Link to="/MembershipsPage">
                  Explore Memberships
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}